/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SymbolWithExchangeDto,
    SymbolWithExchangeDtoFromJSON,
    SymbolWithExchangeDtoFromJSONTyped,
    SymbolWithExchangeDtoToJSON,
} from './SymbolWithExchangeDto';

/**
 * 
 * @export
 * @interface SymbolFundamentalDataHighlightsDto
 */
export interface SymbolFundamentalDataHighlightsDto {
    /**
     * 
     * @type {SymbolWithExchangeDto}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    symbol: SymbolWithExchangeDto;
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    marketCapitalization: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    peRatio: number | null;
    /**
     * earnings before interest, taxes, depreciation, amortization; ebit + depreciationAndAmortization.
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    ebitda: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    epsEstimateCurrentYear: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    dividend: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    dividendYield: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    dividendPayoutRatio: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    margin: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    marginTTM: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    eps: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    roe: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    evEbitda: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    dividendYears: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalDataHighlightsDto
     */
    continuousDividendYears: number | null;
}

export function SymbolFundamentalDataHighlightsDtoFromJSON(json: any): SymbolFundamentalDataHighlightsDto {
    return SymbolFundamentalDataHighlightsDtoFromJSONTyped(json, false);
}

export function SymbolFundamentalDataHighlightsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFundamentalDataHighlightsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbol': SymbolWithExchangeDtoFromJSON(json['symbol']),
        'id': json['id'],
        'marketCapitalization': json['marketCapitalization'],
        'peRatio': json['peRatio'],
        'ebitda': json['ebitda'],
        'epsEstimateCurrentYear': json['epsEstimateCurrentYear'],
        'dividend': json['dividend'],
        'dividendYield': json['dividendYield'],
        'dividendPayoutRatio': json['dividendPayoutRatio'],
        'margin': json['margin'],
        'marginTTM': json['marginTTM'],
        'eps': json['eps'],
        'roe': json['roe'],
        'evEbitda': json['evEbitda'],
        'dividendYears': json['dividendYears'],
        'continuousDividendYears': json['continuousDividendYears'],
    };
}

export function SymbolFundamentalDataHighlightsDtoToJSON(value?: SymbolFundamentalDataHighlightsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbol': SymbolWithExchangeDtoToJSON(value.symbol),
        'id': value.id,
        'marketCapitalization': value.marketCapitalization,
        'peRatio': value.peRatio,
        'ebitda': value.ebitda,
        'epsEstimateCurrentYear': value.epsEstimateCurrentYear,
        'dividend': value.dividend,
        'dividendYield': value.dividendYield,
        'dividendPayoutRatio': value.dividendPayoutRatio,
        'margin': value.margin,
        'marginTTM': value.marginTTM,
        'eps': value.eps,
        'roe': value.roe,
        'evEbitda': value.evEbitda,
        'dividendYears': value.dividendYears,
        'continuousDividendYears': value.continuousDividendYears,
    };
}

